import { ensureAdminUsersList } from "../../utils/tenantSubdomain";

const initState = {

    admin_users: [],
    admin_viewer: null,
    error_message: null,
    edit_user_overlay: null,
    created: false

};

const adminReducer = (state = initState, action) => {


    switch (action.type) {

        case "LOG_USER_OUT":
            return {
                ...initState,
            };

        case "RESET_ADMIN_ERROR":
            return {
                ...state,
                error_message: null,
                created: false
            };

        case "ADMIN_ERROR":
            return {
                ...state,
                error_message: action.error
            };

        case "ADMIN_USERS_UPDATED":
            return {
                ...state,
                admin_users: ensureAdminUsersList(action.users),
                admin_viewer: action.viewer ?? state.admin_viewer,
                created: true
            };

        case "ADMIN_USERS_CREATED":
            return {
                ...state,
                admin_users: ensureAdminUsersList(action.users),
                admin_viewer: action.viewer ?? state.admin_viewer,
                created: true
            };

        case "ADMIN_USERS":
            return {
                ...state,
                admin_users: ensureAdminUsersList(action.users),
                admin_viewer: Object.prototype.hasOwnProperty.call(action, "viewer")
                  ? action.viewer
                  : state.admin_viewer,
            };

        case "EDIT_USER_OVERLAY":
            return {
                ...state,
                edit_user_overlay: action.user_id
            };

        case "RESET_EDIT_USER_OVERLAY":
            return {
                ...state,
                edit_user_overlay: null
            };

        default:
            return state;
    }
};

export default adminReducer;
